import React, { useState } from "react";
import { FiShoppingCart } from "react-icons/fi";
// import { FiUser } from "react-icons/fi";
import { AiFillHeart } from "react-icons/ai";
import ProductSize from "./ProductSize";
// import { AiOutlineHeart } from "react-icons/ai";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { showToast } from "../../services/toastService";


function CartPincodeBtn({ product }) {
  // console.log(product)

  const notifySuccess = (message) => {
    showToast(message, "dark");
  };
  const notifyError = (message) => {
    showToast(message, "warn");
  };

  const [selectedSize, setSelectedSize] = useState(product.options[1] && product.options[1].values ? product.options[1].values[0] : null);
  const [selectedQuantity, setQuantity] = useState(1);

  // const handleSizeChange = (event) => {
  //   setSelectedSize(event.target.value);
  // };

  // const handleQuantityChange = (event) => {
  //   setQuantity(event.target.value);
  // };

  const addToCart = () => {
    let cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];

    
    const isProductInCart = cartItems.some(item => item.id === product.id);

    if (isProductInCart) {
      notifyError("Product is already in the cart");
      return;
  }

    const totalValue = product.variants.nodes[0].price.amount;
    const productToAdd = { ...product, selectedSize, selectedQuantity , totalValue };
    cartItems.push(productToAdd);
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
    // alert("product added");
    notifySuccess('Product Added Succesfull')
  };


  
  const addToWishlist = () => {
    let wishlistItems = JSON.parse(localStorage.getItem("wishlistItems")) || [];

    const isProductInCart = wishlistItems.some(item => item.id === product.id);

    if (isProductInCart) {
      notifyError("Product is already in the wishlist");
      return;
  }
    const totalValue = product.variants.nodes[0].price.amount;
    const productToAdd = { ...product, selectedSize, selectedQuantity , totalValue };
    wishlistItems.push(productToAdd);
    localStorage.setItem("wishlistItems", JSON.stringify(wishlistItems));
    notifySuccess('Product Added Succesfull')

  };
  return (
    <div className="flex flex-col justify-center items-center gap-4 mt-4 cart-size-pincode-and-btn-container">
       {/* <ToastContainer /> */}
      <ProductSize
        product={product}
        selectedSize={selectedSize}
        setSelectedSize={setSelectedSize}
        quantity={selectedQuantity}
        setQuantity={setQuantity}
      />

      <div className="flex flex-col justify-center items-center gap-2 w-full cart-btn-container">
        <button
          onClick={addToCart}
          className="flex justify-center items-center gap-2 bg-black hover:bg-primary p-3 w-full font-primaryFont font-semibold text-[12px] text-white tracking-wider cartbtn"
        >
          ADD TO CART <FiShoppingCart />
        </button>
        
        <button
          onClick={addToWishlist}
          className="flex justify-center items-center gap-2 border-2 p-3 hover:border-black w-full font-primaryFont font-semibold text-[12px] text-primary hover:text-black tracking-wider"
        >
          Add To Wishlist <AiFillHeart />
        </button>
      </div>
      <div
       
        className="flex flex-col justify-center items-center shadow-md hover:shadow-lg mb-4 p-2 p-4 rounded-md w-full transform transition-transform hover:-translate-y-2 duration-500 cursor-pointer pincode-container"
      >
        <p className="font-primaryFont font-semibold text-sm">
          Estimated Delivery Date & COD Checker
        </p>
        <div className="flex justify-between items-center w-full font-primaryFont pin-input-container">
          <input
            type="text"
            className="border-[1px] shadow-none px-4 p-2 w-[80%] text-sm outline-none"
            placeholder="Enter your pincode"
          />
          <button className="bg-black hover:bg-primary p-2 rounded-r-md w-[20%] text-[12px] text-white uppercase tracking-wider cartbtn">
            Check
          </button>
        </div>
      </div>
    </div>
  );
}

export default CartPincodeBtn;
